<app-header></app-header>

<app-banner></app-banner>

<div class="container services-section" style="margin: 3rem auto">
  <div class="row">
    <div class="col-12 col-lg-2 mb-3" style="padding-left: 25px; padding-right: 25px;">
      <h1 style="color: #0e0e0e; font-size: 25px; font-weight: 700;">About Us</h1>
    </div>
    <div class="col-12 col-lg-10" style="padding-left: 25px; padding-right: 25px;">
      <div class="row">
        <h2 style="color: #00943a; font-size: 25px; font-weight: 700;"><strong>What is WorkPASS</strong></h2>
        <p style="color: #0e0e0e;">
          Introducing the newest innovation of the Local Government Unit of Baguio to improve the application of Working
          Permit. The aim of this system is to lessen the processing time and provide a one-stop-shop online and
          minimize interaction between client and government entities.
        </p>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>